export const MAX_CONTENT_WIDTH = '1520px';

export const MAX_SCREEN_WIDTH = `calc(${MAX_CONTENT_WIDTH} + 48px + 48px)`;
